// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json = require("../../../shared/src/Json.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Apollo = require("../../../shared/src/bindings/Apollo.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var WebTypes_User = require("../types/WebTypes_User.bs.js");
var CommonTypes_Jwt = require("../../../shared/src/types/CommonTypes_Jwt.bs.js");
var CommonTypes_Email = require("../../../shared/src/types/CommonTypes_Email.bs.js");
var CommonTypes_Business_Id = require("../../../shared/src/types/business/CommonTypes_Business_Id.bs.js");
var CommonTypes_LongPhoneNumber = require("../../../shared/src/types/CommonTypes_LongPhoneNumber.bs.js");
var CommonTypes_Business_Location = require("../../../shared/src/types/business/CommonTypes_Business_Location.bs.js");

var Raw = {};

var query = "query   {\ncurrentUser  {\n...WebTypes_User   \n}\n\n}\n" + WebTypes_User.query;

function parse(value) {
  var value$1 = value.currentUser;
  return {
          currentUser: !(value$1 == null) ? WebTypes_User.verifyArgsAndParse("WebTypes_User", value$1) : undefined
        };
}

function serialize(value) {
  var value$1 = value.currentUser;
  var currentUser = value$1 !== undefined ? WebTypes_User.serialize(value$1) : null;
  return {
          currentUser: currentUser
        };
}

function serializeVariables(param) {
  
}

function makeVariables(param) {
  
}

function makeDefaultVariables(param) {
  
}

function variables(param) {
  return Json.Encode.object_(/* [] */0);
}

function decode(param) {
  return Relude_Option.map(WebTypes_User.tToR, param.currentUser);
}

var Definition = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  makeDefaultVariables: makeDefaultVariables,
  variables: variables,
  decode: decode
};

var include = Apollo.CreateQuery({
      Raw: Raw,
      query: query,
      variables: variables,
      parse: parse,
      decode: decode
    });

var GetCurrentUser_graphqlQueryAST = include.graphqlQueryAST;

var GetCurrentUser_query = include.query;

var GetCurrentUser_queryStoreError = include.queryStoreError;

var GetCurrentUser_queryResult = include.queryResult;

var GetCurrentUser_queryAsyncData = include.queryAsyncData;

var GetCurrentUser_queryAsyncDataStoreError = include.queryAsyncDataStoreError;

var GetCurrentUser_queryAsyncResult = include.queryAsyncResult;

var GetCurrentUser = {
  Definition: Definition,
  graphqlQueryAST: GetCurrentUser_graphqlQueryAST,
  query: GetCurrentUser_query,
  queryStoreError: GetCurrentUser_queryStoreError,
  queryResult: GetCurrentUser_queryResult,
  queryAsyncData: GetCurrentUser_queryAsyncData,
  queryAsyncDataStoreError: GetCurrentUser_queryAsyncDataStoreError,
  queryAsyncResult: GetCurrentUser_queryAsyncResult
};

var Raw$1 = {};

var query$1 = "query ($businessId: BigInt!)  {\nbusinessLocations(filter: {businessId: {equalTo: $businessId}})  {\nnodes  {\n...CommonTypes_Business_Location   \n}\n\n}\n\n}\n" + CommonTypes_Business_Location.query;

function parse$1(value) {
  var value$1 = value.businessLocations;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.nodes;
    tmp = {
      nodes: value$2.map(function (value) {
            if (!(value == null)) {
              return CommonTypes_Business_Location.verifyArgsAndParse("CommonTypes_Business_Location", value);
            }
            
          })
    };
  }
  return {
          businessLocations: tmp
        };
}

function serialize$1(value) {
  var value$1 = value.businessLocations;
  var businessLocations;
  if (value$1 !== undefined) {
    var value$2 = value$1.nodes;
    var nodes = value$2.map(function (value) {
          if (value !== undefined) {
            return CommonTypes_Business_Location.serialize(value);
          } else {
            return null;
          }
        });
    businessLocations = {
      nodes: nodes
    };
  } else {
    businessLocations = null;
  }
  return {
          businessLocations: businessLocations
        };
}

function serializeVariables$1(inp) {
  return {
          businessId: inp.businessId
        };
}

function makeVariables$1(businessId, param) {
  return {
          businessId: businessId
        };
}

function variables$1(param) {
  return Json.Encode.object_({
              hd: [
                "businessId",
                Curry._1(CommonTypes_Business_Id.encode, param.id)
              ],
              tl: /* [] */0
            });
}

function decode$1(param) {
  var match = param.businessLocations;
  if (match !== undefined) {
    return Relude_Option.pure(Curry._1(CommonTypes_Business_Location.$$Set.fromArray, Relude_Array.mapOption((function (param) {
                          return Relude_Option.map(CommonTypes_Business_Location.tToR, param);
                        }), match.nodes)));
  }
  
}

var Definition$1 = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1,
  variables: variables$1,
  decode: decode$1
};

var include$1 = Apollo.CreateQuery({
      Raw: Raw$1,
      query: query$1,
      variables: variables$1,
      parse: parse$1,
      decode: decode$1
    });

var GetSavedLocations_graphqlQueryAST = include$1.graphqlQueryAST;

var GetSavedLocations_query = include$1.query;

var GetSavedLocations_queryStoreError = include$1.queryStoreError;

var GetSavedLocations_queryResult = include$1.queryResult;

var GetSavedLocations_queryAsyncData = include$1.queryAsyncData;

var GetSavedLocations_queryAsyncDataStoreError = include$1.queryAsyncDataStoreError;

var GetSavedLocations_queryAsyncResult = include$1.queryAsyncResult;

var GetSavedLocations = {
  Definition: Definition$1,
  graphqlQueryAST: GetSavedLocations_graphqlQueryAST,
  query: GetSavedLocations_query,
  queryStoreError: GetSavedLocations_queryStoreError,
  queryResult: GetSavedLocations_queryResult,
  queryAsyncData: GetSavedLocations_queryAsyncData,
  queryAsyncDataStoreError: GetSavedLocations_queryAsyncDataStoreError,
  queryAsyncResult: GetSavedLocations_queryAsyncResult
};

var Raw$2 = {};

var query$2 = "mutation signinWithEmail($email: String!, $password: String!)  {\nsigninWithEmail(input: {email: $email, password: $password})  {\njwt  \n}\n\n}\n";

function parse$2(value) {
  var value$1 = value.signinWithEmail;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.jwt;
    tmp = {
      jwt: !(value$2 == null) ? Caml_option.some(CommonTypes_Jwt.GraphQL_API.parse(value$2)) : undefined
    };
  }
  return {
          signinWithEmail: tmp
        };
}

function serialize$2(value) {
  var value$1 = value.signinWithEmail;
  var signinWithEmail;
  if (value$1 !== undefined) {
    var value$2 = value$1.jwt;
    var jwt = value$2 !== undefined ? Curry._1(CommonTypes_Jwt.GraphQL_API.serialize, Caml_option.valFromOption(value$2)) : null;
    signinWithEmail = {
      jwt: jwt
    };
  } else {
    signinWithEmail = null;
  }
  return {
          signinWithEmail: signinWithEmail
        };
}

function serializeVariables$2(inp) {
  return {
          email: inp.email,
          password: inp.password
        };
}

function makeVariables$2(email, password, param) {
  return {
          email: email,
          password: password
        };
}

function variables$2(param) {
  return Json.Encode.object_({
              hd: [
                "email",
                param.email
              ],
              tl: {
                hd: [
                  "password",
                  param.password
                ],
                tl: /* [] */0
              }
            });
}

function decode$2(param) {
  var match = param.signinWithEmail;
  if (match !== undefined) {
    return match.jwt;
  }
  
}

var Definition$2 = {
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2,
  makeVariables: makeVariables$2,
  variables: variables$2,
  decode: decode$2
};

var include$2 = Apollo.CreateMutation({
      Raw: Raw$2,
      query: query$2,
      variables: variables$2,
      parse: parse$2,
      decode: decode$2
    });

var Signin_graphqlMutationAST = include$2.graphqlMutationAST;

var Signin_mutate = include$2.mutate;

var Signin_mutateStoreError = include$2.mutateStoreError;

var Signin_mutateResult = include$2.mutateResult;

var Signin_mutateResultStore = include$2.mutateResultStore;

var Signin_mutateAsyncData = include$2.mutateAsyncData;

var Signin_mutateAsyncResult = include$2.mutateAsyncResult;

var Signin_mutateAsycResultApolloError = include$2.mutateAsycResultApolloError;

var Signin = {
  Definition: Definition$2,
  graphqlMutationAST: Signin_graphqlMutationAST,
  mutate: Signin_mutate,
  mutateStoreError: Signin_mutateStoreError,
  mutateResult: Signin_mutateResult,
  mutateResultStore: Signin_mutateResultStore,
  mutateAsyncData: Signin_mutateAsyncData,
  mutateAsyncResult: Signin_mutateAsyncResult,
  mutateAsycResultApolloError: Signin_mutateAsycResultApolloError
};

var Raw$3 = {};

var query$3 = "query ($email: Email!)  {\nemailIsAvailable(email: $email)  \n}\n";

function parse$3(value) {
  var value$1 = value.emailIsAvailable;
  return {
          emailIsAvailable: !(value$1 == null) ? value$1 : undefined
        };
}

function serialize$3(value) {
  var value$1 = value.emailIsAvailable;
  var emailIsAvailable = value$1 !== undefined ? value$1 : null;
  return {
          emailIsAvailable: emailIsAvailable
        };
}

function serializeVariables$3(inp) {
  return {
          email: inp.email
        };
}

function makeVariables$3(email, param) {
  return {
          email: email
        };
}

function variables$3(email) {
  return Json.Encode.object_({
              hd: [
                "email",
                Curry._1(CommonTypes_Email.encode, email)
              ],
              tl: /* [] */0
            });
}

function decode$3(param) {
  return param.emailIsAvailable;
}

var Definition$3 = {
  Raw: Raw$3,
  query: query$3,
  parse: parse$3,
  serialize: serialize$3,
  serializeVariables: serializeVariables$3,
  makeVariables: makeVariables$3,
  variables: variables$3,
  decode: decode$3
};

var include$3 = Apollo.CreateQuery({
      Raw: Raw$3,
      query: query$3,
      variables: variables$3,
      parse: parse$3,
      decode: decode$3
    });

var EmailAvailable_graphqlQueryAST = include$3.graphqlQueryAST;

var EmailAvailable_query = include$3.query;

var EmailAvailable_queryStoreError = include$3.queryStoreError;

var EmailAvailable_queryResult = include$3.queryResult;

var EmailAvailable_queryAsyncData = include$3.queryAsyncData;

var EmailAvailable_queryAsyncDataStoreError = include$3.queryAsyncDataStoreError;

var EmailAvailable_queryAsyncResult = include$3.queryAsyncResult;

var EmailAvailable = {
  Definition: Definition$3,
  graphqlQueryAST: EmailAvailable_graphqlQueryAST,
  query: EmailAvailable_query,
  queryStoreError: EmailAvailable_queryStoreError,
  queryResult: EmailAvailable_queryResult,
  queryAsyncData: EmailAvailable_queryAsyncData,
  queryAsyncDataStoreError: EmailAvailable_queryAsyncDataStoreError,
  queryAsyncResult: EmailAvailable_queryAsyncResult
};

var Raw$4 = {};

var query$4 = "query ($phoneNumber: PhoneNumber!)  {\nphoneNumberIsAvailable(phoneNumber: $phoneNumber)  \n}\n";

function parse$4(value) {
  var value$1 = value.phoneNumberIsAvailable;
  return {
          phoneNumberIsAvailable: !(value$1 == null) ? value$1 : undefined
        };
}

function serialize$4(value) {
  var value$1 = value.phoneNumberIsAvailable;
  var phoneNumberIsAvailable = value$1 !== undefined ? value$1 : null;
  return {
          phoneNumberIsAvailable: phoneNumberIsAvailable
        };
}

function serializeVariables$4(inp) {
  return {
          phoneNumber: inp.phoneNumber
        };
}

function makeVariables$4(phoneNumber, param) {
  return {
          phoneNumber: phoneNumber
        };
}

function variables$4(phoneNumber) {
  return Json.Encode.object_({
              hd: [
                "phoneNumber",
                CommonTypes_LongPhoneNumber.encode(phoneNumber)
              ],
              tl: /* [] */0
            });
}

function decode$4(param) {
  return param.phoneNumberIsAvailable;
}

var Definition$4 = {
  Raw: Raw$4,
  query: query$4,
  parse: parse$4,
  serialize: serialize$4,
  serializeVariables: serializeVariables$4,
  makeVariables: makeVariables$4,
  variables: variables$4,
  decode: decode$4
};

var include$4 = Apollo.CreateQuery({
      Raw: Raw$4,
      query: query$4,
      variables: variables$4,
      parse: parse$4,
      decode: decode$4
    });

var PhoneNumberAvailable_graphqlQueryAST = include$4.graphqlQueryAST;

var PhoneNumberAvailable_query = include$4.query;

var PhoneNumberAvailable_queryStoreError = include$4.queryStoreError;

var PhoneNumberAvailable_queryResult = include$4.queryResult;

var PhoneNumberAvailable_queryAsyncData = include$4.queryAsyncData;

var PhoneNumberAvailable_queryAsyncDataStoreError = include$4.queryAsyncDataStoreError;

var PhoneNumberAvailable_queryAsyncResult = include$4.queryAsyncResult;

var PhoneNumberAvailable = {
  Definition: Definition$4,
  graphqlQueryAST: PhoneNumberAvailable_graphqlQueryAST,
  query: PhoneNumberAvailable_query,
  queryStoreError: PhoneNumberAvailable_queryStoreError,
  queryResult: PhoneNumberAvailable_queryResult,
  queryAsyncData: PhoneNumberAvailable_queryAsyncData,
  queryAsyncDataStoreError: PhoneNumberAvailable_queryAsyncDataStoreError,
  queryAsyncResult: PhoneNumberAvailable_queryAsyncResult
};

exports.GetCurrentUser = GetCurrentUser;
exports.GetSavedLocations = GetSavedLocations;
exports.Signin = Signin;
exports.EmailAvailable = EmailAvailable;
exports.PhoneNumberAvailable = PhoneNumberAvailable;
/* include Not a pure module */
